<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/ciudades/#ciudades">Ciudades</a>
            </li>
            <li class="is-size-5">
                <a href="/sepomex/ciudades/#ciudad">Ciudad</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="ciudades">1.- Ciudades</h3>
        <strong>
            Enpoint con la lista de ciudades, siempre regresa un array de objetos, incluso aunque sea solo un elemento<br>
            Todos los municipios tienen una ciudad INDETERMINADA debido al propio sepomex
        </strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/ciudades/</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 282)</li>
                    </ul>
                </li>
                <li>
                    <strong>stateId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 8)</li>
                    </ul>
                </li>
                <li>
                    <strong>municipioId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 21)</li>
                    </ul>
                </li>
                <li>
                    <strong>activo</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato boolean (Ej. true, 1, yes, false, 0, no)</li>
                    </ul>
                </li>
                <li>
                    <strong>nombre</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'chihuahua' )</li>
                    </ul>
                </li>
            </ul>
        </div>

       
        <h5 class="is-size-6 has-text-weight-bold">Respuesta 1 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/ciudades?municipioId=21</h5>
            <code>[
                {
                    "id": 1797,
                    "stateId": 2,
                    "municipioId": 21,
                    "nombre": "ENSENADA",
                    "activo": true
                },
                {
                    "id": 1823,
                    "stateId": 2,
                    "municipioId": 21,
                    "nombre": "INDETERMINADA",
                    "activo": true
                },
                {
                    "id": 3003,
                    "stateId": 2,
                    "municipioId": 21,
                    "nombre": "RODOLFO SÁNCHEZ TABOADA (MANEADERO)",
                    "activo": true
                }
            ]</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/ciudades?nombre=chihuahua</h5>
            <code>[
                {
                    "id": 1150,
                    "stateId": 8,
                    "municipioId": 282,
                    "nombre": "CHIHUAHUA",
                    "activo": true
                }
            ]</code>
        </pre>
        <hr />

        <h3 class="is-size-3" id="ciudad">2.- Ciudad</h3>
        <strong>Enpoint con el detalle de un solo ciudad, siempre regresa un objeto.</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/ciudad/{id}</code>
        </p>

        <h5 class="is-size-6">Parametros:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato number (Ej. 2685)</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/ciudad/2685</h5>
            <code>{
                "id": 2685,
                "stateId": 15,
                "municipioId": 997,
                "nombre": "SAN MATEO ATENCO",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/ciudad/801</h5>
            <code>{
                "id": 801,
                "stateId": 19,
                "municipioId": 1399,
                "nombre": "CIÉNEGA DE FLORES",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 3 de Ejemplo, ciudad no encontrada:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/ciudad/50000</h5>
            <code>{}</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexCiudades',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
